import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-dialog-parcela-confirmacao',
  templateUrl: './dialog-parcela-confirmacao.component.html',
  styleUrls: ['./dialog-parcela-confirmacao.component.css'],
  imports: [MatDialogModule]
})
export class DialogParcelaConfirmacaoComponent {
  
  constructor(public dialogRef: MatDialogRef<DialogParcelaConfirmacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }) { }

  fecharDialogo(acao: string): void {
    // Fecha o diálogo e passa o valor da ação para o componente chamador
    this.dialogRef.close(acao);
  }
}
